/**
 * Optimized Sign-Up Field Map
 * Uses MutationObserver for performance and native DOM methods for traversal.
 */
(function () {
  const CONFIG = {
    fieldIds: ['billing_address_first_name', 'billing_address_last_name', 'billing_address_recipient'],
    targetClass: 'FieldLine_', // Used with [class*=""] for native speed
    timeout: 10000 // Reduced from 30s to 10s (standard UX limit)
  };

  /**
   * Efficiently finds an element across Shadow DOM boundaries
   */
  const queryDeep = (selector, root = document) => {
    const found = root.querySelector(selector);
    if (found) return found;

    const hosts = root.querySelectorAll('shopify-forms-embed');
    for (const el of hosts) {
      if (el.shadowRoot) {
        const deepFound = queryDeep(selector, el.shadowRoot);
        if (deepFound) return deepFound;
      }
    }
    return null;
  };

  /**
   * Locates the field and hides its specific container
   */
  const processFields = () => {
    CONFIG.fieldIds = CONFIG.fieldIds.filter((id) => {
      const el = queryDeep(`#${id}`);
      if (!el) return true; // Keep in list to try again

      // Find the closest parent containing the partial class name
      const container = el.closest(`[class*="${CONFIG.targetClass}"]`);
      if (container) {
        container.style.display = 'none';
        return false; // Successfully hidden, remove from list
      }
      return true;
    });

    return CONFIG.fieldIds.length === 0;
  };

  const init = () => {
    // Initial execution
    if (processFields()) return;

    // Set up MutationObserver to watch for dynamic Shopify form injections
    const observer = new MutationObserver(() => {
      if (processFields()) observer.disconnect();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Fail-safe: Stop observing after timeout
    setTimeout(() => {
      observer.disconnect();
      if (CONFIG.fieldIds.length > 0) {
        console.warn('[sign-up-field-map] Could not hide fields:', CONFIG.fieldIds);
      }
    }, CONFIG.timeout);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
